import { downFile, fileToJson } from "@/utils/tool";
import request from "@/utils/request";
import loadingDirective from "@/directive/loading";
// import 'link-ui-web/lib/theme-chalk/index.css';
// import { MessageBox } from 'link-ui-web';
import { EventBus } from "@/utils/eventBus";

export default {
  props: {
    previewData: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  directives: {
    loading: loadingDirective,
  },
  data() {
    return {
      loading: false,
      isDownloading: false,
    };
  },
  methods: {
    /**
     * 预览资源请求
     * @returns {Promise<AxiosResponse<any>|boolean>}
     */
    async getBlobData() {
      this.loading = true;
      const res = await request.get(this.previewData.fileUrl, {
        responseType: "blob",
      });
      this.loading = false;
      if (res.data.type === "application/json") {
        const result = await fileToJson(res.data);
        // console.log('result', result);
        // 弹框提示
        // MessageBox.confirm(result.message, '提示', {
        //   confirmButtonText: '好的',
        //   showClose: false,
        //   showCancelButton: false,
        //   type: 'error'
        // }).then(() => {
        // EventBus.$emit('close');
        // });
        console.error(result.message);
        EventBus.$emit("close");
        return false;
      } else {
        console.log("res222", res);
        return res;
      }
    },
    /**
     * 资源下载
     * @returns {Promise<void>}
     */
    async handleDownload() {
      console.log("filePreview Download");
      this.isDownloading = true;
      const res = await request.get(this.previewData.fileUrl, {
        responseType: "blob",
      });
      this.isDownloading = false;
      if (res.data.type === "application/json") {
        const result = await fileToJson(res.data);
        console.log("result", result);
        // 弹框提示
        // MessageBox.confirm(result.message, "提示", {
        //   confirmButtonText: "好的",
        //   showClose: false,
        //   showCancelButton: false,
        //   type: "error",
        // }).then(() => {
        //   EventBus.$emit("close");
        // });
        console.error(result.message);
        EventBus.$emit("close");
        return false;
      } else {
        downFile(
          res.data,
          this.previewData.fileName,
          res.headers["content-type"]
        );
      }
    },
  },
};
